'use strict';

(function() {
	angular.module('onboarding.common')
		.directive('cobCanadianValidation', cobCanadianValidation);

	cobCanadianValidation.$inject = [
		'$log', '$timeout', '$state', 'subjectObserverMessagesService', 'observerService', 'sessionService',
		'carrierRegistrationService', 'authenticationService', '$window'
	];

	var $log,
		$timeout,
		$state,
		subjectObserverMessagesService,
		observerService,
		sessionService,
		subjectMessages,
		observerMessages,
		carrierRegistrationService,
		authenticationService,
		$window;

	function cobCanadianValidation(_$log_,
		_$timeout_,
		_$state_,
		_subjectObserverMessagesService_,
		_observerService_,
		_sessionService_,
		_carrierRegistrationService_,
		_authenticationService_,
		_$window_) {
		$log = _$log_;
		$timeout = _$timeout_;
		$state = _$state_;
		subjectObserverMessagesService = _subjectObserverMessagesService_;
		observerService = _observerService_;
		sessionService = _sessionService_;
		carrierRegistrationService = _carrierRegistrationService_;
		authenticationService = _authenticationService_;
		$window = _$window_;

		return {
			restrict: 'E',
			scope: {
				visible: '='
			},
			replace: true,
			templateUrl: '/app/common/welcome/canadianValidation.html',
			link: linkFunction
		};
	}

	function linkFunction(scope) {

		activate();

		function activate() {
			subjectMessages = subjectObserverMessagesService.getSubjectMessages();
			observerMessages = subjectObserverMessagesService.getObserverMessages();

			scope.m = {
				datNumber: '',
				province: '',
				datNumberValidationMessage: '',
				provinceValidationMessage: '',
				provinceList: [
					{ key: 'AB', value: 'Alberta' },
					{ key: 'BC', value: 'British Columbia' },
					{ key: 'MB', value: 'Manitoba' },
					{ key: 'NB', value: 'New Brunswick' },
					{ key: 'NF', value: 'Newfoundland and Labrador' },
					{ key: 'NT', value: 'Northwest Territories' },
					{ key: 'NS', value: 'Nova Scotia' },
					{ key: 'NU', value: 'Nunavut' },
					{ key: 'ON', value: 'Ontario' },
					{ key: 'PE', value: 'Prince Edward Island' },
					{ key: 'PQ', value: 'Quebec' },
					{ key: 'SK', value: 'Saskatchewan' },
					{ key: 'YT', value: 'Yukon Territory' }
				]
			};

			scope.validateDatNumber = validateDatNumber;
			scope.setActiveSlide = setActiveSlide;
			scope.openLiveChat = openLiveChat;
			scope.niceInContactEnabled = false;
			scope.sessionService = sessionService;

			sessionService.getApplicationSettings()
				.then(function (response) {
					scope.niceInContactEnabled = response.niceInContactEnabled;
				});
		}

		function setActiveSlide(slide) {
			scope.m.datNumberValidationMessage = '';
			scope.m.provinceValidationMessage = '';
			scope.m.showNotFound = '';
			scope.m.datNumber = '';
			scope.m.province = '';

			observerService.sendMessageToSubject(scope,
				subjectObserverMessagesService.getSubjectMessages().COB_SUBJECT_CHANGE_WELCOME_VIEW,
				{
					setActiveSlide: slide
				});
		}

		function openLiveChat() {
			if (!scope.niceInContactEnabled) {
				return;
			}
			openNiceinContactAgentChat();
		}

		function validateDatNumber() {
			scope.m.datNumberValidationMessage = '';
			scope.m.provinceValidationMessage = '';

			if (scope.m.province.length === 0) {

				scope.m.provinceValidationMessage = 'Valid input is required';
			}
			if (scope.m.datNumber.length === 0) {
				scope.m.datNumberValidationMessage += 'Valid input is required';
			}
			if (scope.m.datNumberValidationMessage === '' && scope.m.provinceValidationMessage === '') {
				setTimeout(function() {
					observerService
						.sendMessageToSubject(scope,
							subjectObserverMessagesService.getSubjectMessages().COB_SUBJECT_AJAX_WAITING);
				},
				1);

				carrierRegistrationService.validateIntrastateCode(scope.m.province.key, scope.m.datNumber)
					.then(function(response) {
						switch (response.data.validationInfo) {
						case 'Authorized':
							if (response.data.carrierId !== -1) {
								observerService.sendMessageToSubject(scope,
									subjectObserverMessagesService.getSubjectMessages().COB_SUBJECT_CHANGE_WELCOME_VIEW,
									{
										modalMessage:
										'<br/><p><strong>The information provided matches an existing ' +
										'account. <a href="' + authenticationService.getLogoutUrl() + '">Please follow this link to log in</a>. ' +
										'You will be redirected to a new screen.</strong></p>',
										modalTitle: 'Account Found'
									});
							} else {
								observerService.sendMessageToSubject(scope,
									subjectObserverMessagesService.getSubjectMessages()
										.COB_SUBJECT_CHANGE_WELCOME_VIEW,
									{
										setActiveSlide: 'confirmCompanySection',
										carrierList: response.data.carrierList,
										numberText: 'Number entered:',
										searchNumber: scope.m.province.key + '/' + scope.m.datNumber,
										modalMessage: '',
										modalTitle: ''
									});
								scope.m.datNumber = '';
								scope.m.province = '';
							}
							break;
						case 'IntrastateCodeNotFound':
							scope.m
								.showNotFound =
                                'No match found in the DAT Registry. To discuss how to include your business in the DAT Registry, see the chat link below the submit button, or call 800-551-8836.';
							break;
						}

					})
					.catch(function(e) {
						console.log(e);
					})
					.finally(function() {
						observerService
							.sendMessageToSubject(scope,
								subjectObserverMessagesService.getSubjectMessages().COB_SUBJECT_AJAX_DONE);
					});
			}
		}

		function openNiceinContactAgentChat() {
			var niceInContactBaseUrl = 'https://home-c37.nice-incontact.com/inContact/ChatClient/ChatClient.aspx?poc={0}&bu={1}&P1={2}&P2={3}; {4}&P3={5}&P4={6}';
			var pointOfContact = '0893c22c-11b6-4b47-943f-649d809655d7';
			var businessUnit = '4599687';
			var niceInContactChatClient = niceInContactBaseUrl
				.replace('{0}', pointOfContact)
				.replace('{1}', businessUnit)
				.replace('{2}', 'DAT OnBoard Guest')
				.replace('{3}', 'guest-user')
				.replace('{4}', 'DOBGuest@dat.com')
				.replace('{5}', '')
				.replace('{6}', $window.location.href);

			console.log(niceInContactChatClient);

			var baseWindowOptions = 'location=no, menubar=no, status=no, resizable=no, height={0}, width={1}, top={2}, left={3}';
			var width = 410;
			var height = 700;

			var top = $window.outerHeight / 2 + $window.screenY - (height / 2);
			var left = $window.outerWidth / 2 + $window.screenX - (width / 2);

			var windowOptions = baseWindowOptions
				.replace('{0}', height)
				.replace('{1}', width)
				.replace('{2}', top)
				.replace('{3}', left);

			console.log(windowOptions);
			$window.open(niceInContactChatClient, 'niceInContactChat', windowOptions);
		}

		return;
	}
})();
